
import { isBlank, compact } from 'vessel/utils'

export default {
  name: 'VsBreadcrumbItem',
  props: {
    to: {
      type: [String, Object],
      default: null
    },
    replace: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'span'
    }
  },
  vessel: {
    wrapper: {
      $attrs: 'all',
      fontSize: 'sm',
      $isLink: {
        fontWeight: val => val ? 'bold' : null,
        cursor: val => val ? 'pointer' : null,
        hover: {
          color: val => val ? 'primary' : null
        }
      }
    }
  },
  computed: {
    isLink() {
      return this.to && !isBlank(compact(this.to))
    }
  },
  methods: {
    onClick() {
      if (this.isLink) {
        if (this.replace) {
          this.$router.replace(this.to)
        } else {
          this.$router.push(this.to)
        }
      }
    }
  }
}
